import OnlineOnboarding from './online-onboarding';

export default OnlineOnboarding;
